
import { Component, Vue } from "vue-property-decorator";
import TakipHazirlaFormBetaWizard from "@/components/forms/form-wizard/eicrapro/TakipHazirlaFormBetaWizard.vue";
import UyapBagliDegilView from "@/views/eicrapro/UyapBagliDegilView.vue";

@Component({
  components: {
    TakipHazirlaFormBetaWizard,
    UyapBagliDegilView
  }
})
export default class TakipHazirlaBetaView extends Vue {

}
